import { useHardFacts } from "@/contexts/classified";
import { FactMapIcon } from "./constants";
export const useFacts = () => {
    var _a;
    const data = (_a = useHardFacts()) === null || _a === void 0 ? void 0 : _a.facts;
    const facts = data === null || data === void 0 ? void 0 : data.map((fact) => (Object.assign(Object.assign({}, fact), { Icon: FactMapIcon[fact.type] })));
    return facts;
};
